module.exports = __webpack_public_path__ + "img/help_blue.2a10266c.svg";